export const EVENTS = {
  COUNTRY: {
    SELECT: 'country.select',
    SELECTED: 'country.selected',
    SELECTION_CONFIRMED: 'country.selection_confirmed',
    SELECTION_CLICKED: 'country.selection_clicked',
  },
  CURRENCY: {
    SELECT: 'currency.select',
    SELECTED: 'currency.selected',
    SELECTION_CONFIRMED: 'currency.selection_confirmed',
    SELECTION_CLICKED: 'currency.selection_clicked',
    MULTI_SELECT: 'currency.multi_select'
  }
};